module.exports = __webpack_public_path__ + "static/media/compare-button-selected-partial.56761fc2.svg";